enum FinancingRequestStatusEnum {
  Submitted = 1,
  Approved = 2,
  Rejected = 3,
  Returned = 4,
  Draft = 5
}

export default FinancingRequestStatusEnum;
